import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { pyrotchBaseUrl } from '../axios/AxiosInstance';

export interface TaskResponse {
  data: {
    [key: string]: string[]; 
  };
  message: string;
  status: number;
}

// Define the API service
export const NotificationApi = createApi({
  reducerPath: 'notificationApi',
  baseQuery: fetchBaseQuery({
    baseUrl: pyrotchBaseUrl + "v1/",
    prepareHeaders: (headers, { getState }) => {
      const state = getState() as RootState;
      const user = state.auth.user;
      const parsedUser = typeof user === "string" ? JSON.parse(user) : user;
      const jwtToken = parsedUser?.jwtToken;

      if (jwtToken) {
        headers.set('Authorization', `Bearer ${jwtToken}`);
      headers.set('ngrok-skip-browser-warning', 'true');
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    getNotifications: build.query({
      query: ({ notificationType, readStatus, approval, filterUserId, page, size, search}) => ({
        url: 'notification/user',
        method: 'POST',
        body : { notificationType, readStatus, approval, filterUserId, page, size, search },
      }),
      keepUnusedDataFor: 0,
    }),

    readNotification: build.mutation<void, { notificationId: number }>({
      query: ({ notificationId }) => ({
        url: 'notification/notification-read',
        method: 'PUT',
        params: { notificationId },
      }),
    }),

    getNotificationCount: build.query({
      query: () => ({
        url: 'notification/notifications/unread-count',
        method: 'GET',
      })
    }),

    getNotificationDropdown : build.query<TaskResponse, void>({
      query: () => ({
        url: 'notification',
        method: 'GET',
      })
    })
  }),
});

export const { useGetNotificationsQuery, useReadNotificationMutation, useLazyGetNotificationCountQuery , useLazyGetNotificationsQuery ,useGetNotificationDropdownQuery} = NotificationApi;


